export default "__VITE_ASSET__DQt5gOGW__"